import { Injectable } from "@angular/core";
import { BaseApiService } from "./base.service";
import { Observable } from "rxjs";
import { FeedbackType } from "../models/message";

@Injectable({
    providedIn: "root",
})
export class FeedbackService extends BaseApiService {
    protected readonly resourcePath = "feedback";

    public sendFeedback(messageId: string, feedbackType: FeedbackType): Observable<void> {
        const params = { type: feedbackType, source: "user" };
        return this._http.post<void>(`${this._baseUrl}/${messageId}`, params);
    }
}
